import {
  paletteHelper,
  P,
  spacingHelper,
  Button as CKButton,
  mediaHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useSearchLandingPageModalContext } from '../../contexts/SearchLandingPageModalContext/SearchLandingPageModalContext';
import { trackSearchRefinementModalOpen } from '../../../analytics/event-tracking/trackSearchRefinementModalOpen';
import { mapButtonVariant } from '../../../app-kit/helpers/mapButtonVariant';
import { Button } from '../../../types';

const Container = styled.div`
  padding: ${spacingHelper('extraLarge')} 0;
  position: relative;
  text-align: center;
  width: 100%;

  &:first-child {
    padding-top: 0;
  }
`;

const Part1 = styled(P)`
  color: ${paletteHelper('textSecondary')};
  margin-bottom: ${spacingHelper('extraLarge')};
`;

const SecondaryMessaging = styled.div`
  margin-top: -${spacingHelper('small')};
  width: 100%;

  ${mediaHelper('tabletMin')} {
    margin-top: -${spacingHelper('large')};
  }
`;

const Part2 = styled(P)`
  color: ${paletteHelper('textSecondary')};
`;

const Part3 = styled(P)`
  color: ${paletteHelper('textSecondary')};
`;

const Image = styled.img<{ $aspectRatio?: string }>`
  height: auto;
  max-width: 640px;
  width: 100%;
  ${({ $aspectRatio }) => `aspect-ratio:${$aspectRatio};`}
`;
export type ResultsBannerImage = {
  name: string;
  alt: string;
  aspectRatio: string;
};
interface ResultsBannerProps {
  part3?: string | null;
  part2?: string | null;
  part1?: string | null;
  image?: ResultsBannerImage | null;
  action?: Button | null;
}

export const SearchLandingPageResultsBanner: FunctionComponent<ResultsBannerProps> = ({
  part1,
  part2,
  part3,
  action,
  image,
}) => {
  const imagePath = image ? image.name : null;
  const { displayModal } = useSearchLandingPageModalContext();
  const openModal = () => {
    displayModal('location');
    trackSearchRefinementModalOpen('location');
  };

  return (
    <Container>
      {part1 && <Part1 variant="subtitle01">{part1}</Part1>}
      {image && imagePath && (
        <Image src={imagePath} alt={image?.alt} $aspectRatio={image?.aspectRatio} />
      )}
      <SecondaryMessaging>
        {part2 && <Part2 variant="subtitle02">{part2}</Part2>}
        {part3 && <Part3 variant="subtitle01">{part3}</Part3>}
        {action && (
          <CKButton onClick={openModal} variant={mapButtonVariant(action.buttonVariant)}>
            {action.text}
          </CKButton>
        )}
      </SecondaryMessaging>
    </Container>
  );
};
